import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Spinner } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import {
  dropdownData,
  exportToExcel,
  formatNumber,
  getRecords,
} from "../../services/api.service";
import SelectInput from "../../custom/components/Select-Input/SelectInput";

const ViewStocks = () => {
  const headerName = "STOCK";
  const { id } = useParams;
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [warehouseSelect, setWarehouseSelect] = useState("");
  const [warehouseSelectOptions, setWarehouseSelectOptions] = useState([]);
  const [itemSelect, setItemSelect] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [warehouseError, setWarehouseError] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    getWarehouseDropData();
  }, []);

  useEffect(() => {
    if (warehouseSelect) {
      getStockData(warehouseSelect?.value);
    }
  }, [searchKeyword]);

  const getWarehouseDropData = async () => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));

    try {
      let payload = {
        modelName: "warehouse_masters",
        whereCondition: {
          is_active: true,
          project_id: projectId,
        },
      };
      const responseData = await getRecords(payload, "/getWarehouseListing");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "warehouse_name"
        );
        setWarehouseSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getStockData = async (Id) => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      let payload = {
        modelName: "stocks",
        whereCondition: {
          warehouse_id: Id,
          project_id: projectId,
        },
        relations: [
          {
            module: "item_masters",
            moduleAs: "makeItem",
          },
          {
            module: "item_masters",
            moduleAs: "buyItem",
            subModule: "uom_masters",
            subModuleAs: "uom",
          },
        ],
        search: {
          field_name: ["makeItem.item_code", "buyItem.item_code"],
          searchKeyword: searchKeyword?.trim(),
        },
        modifyResponse: true,
      };

      let responseData = await getRecords(payload, "/getRecords");
      if (responseData.data == 0) {
        setFilteredItems([]);
      }
      if (responseData.data && responseData.data.length > 0) {
        // responseData.data = responseData?.data.filter((data) => data.stock_qty);

        const stockItems = responseData?.data?.map((item) => ({
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.makeItem?.item_code,
          buy_item_code: item?.buyItem?.item_code,
          description: item?.buyItem?.description,
          make_item_desc: item?.makeItem?.description,
          uom: item.buyItem.uom?.uom_name,
          stock_qty: item?.stock_qty,
          inward_qty: item?.inward_qty,
          outward_qty: item?.outward_qty,
          // consumable_qty: item?.consumable_qty,

          hold_scrab_qty: item?.hold_scrab_qty,
          shortage_qty: item?.shortage_qty,
          provision_qty: item?.provision_qty,
          mrb_qty: item?.mrb_qty,
          scrab_qty: item?.scrab_qty,
          is_make_item: item?.is_make_item,
          is_active: true,
          type: item?.itemDetails?.type,
          faulty_qty: item.faulty_qty,
          id: item.id,
          is_show: false,
          make_buy_name: item?.is_make_item
            ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
            : item?.buyItem?.item_code,
        }));
        setFilteredItems(stockItems);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const groupedItems = filteredItems.reduce((acc, item) => {
    if (!acc[item.item_code]) {
      acc[item.item_code] = { makeItem: item, buyItems: [] };
    }

    if (item.buy_item_code) {
      acc[item.item_code].buyItems.push(item);
    }

    return acc;
  }, {});
  let serialNumber = 1;

  const handleWarehouseSelect = (options) => {
    const selectedValue = options ? options.value : null;
    setWarehouseSelect(options);
    setSearchKeyword("");
    setItemSelect("");
    setFilteredItems([]);
    if (selectedValue) {
      setWarehouseError(false);
      getStockData(selectedValue);
    } else {
      setWarehouseError(true);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
  };

  const FloatValue = (value) => {
    return parseFloat(value)?.toFixed(3);
  };
  const handleExportData = () => {
    let serialNo = 1;
    const exportData = Object.values(groupedItems).flatMap((group) => {
      const makeItemData = group.makeItem.is_make_item
        ? [
            {
              "Sr. No": serialNo,
              Warehouse: warehouseSelect?.label || "N/A",
              "Item Code": group.makeItem.item_code || "N/A",
              "Item Desc": group.makeItem.make_item_desc || "N/A",
              "Stock QTY": "-",
              "Inward QTY": "-",
              "Outward QTY": "-",
              // "Consumable QTY": "-",
              "Shortage QTY": "-",
              "Provision QTY": "-",
              "MRB QTY": "-",
              "Scrap QTY": "-",
              "Hold Scrap QTY": "-",
            },
          ]
        : [];

      const buyItemsData = group.buyItems.map((item, subIndex) => ({
        "Sr. No": group.makeItem.is_make_item
          ? `${serialNo}.${subIndex + 1}`
          : serialNo,
        Warehouse: warehouseSelect?.label || "N/A",
        "Item Code": item.is_make_item ? item.buy_item_code : item.item_code,
        "Item Desc": item.is_make_item ? item.description : item.make_item_desc,
        "Stock QTY": parseFloat(item.stock_qty || 0),
        "Inward QTY": parseFloat(item.inward_qty || 0),
        "Outward QTY": parseFloat(item.outward_qty || 0),
        // "Consumable QTY": parseFloat(item.consumable_qty || 0),

        "Shortage QTY": parseFloat(item.shortage_qty || 0),
        "Provision QTY": parseFloat(item.provision_qty || 0),
        "MRB QTY": parseFloat(item.mrb_qty || 0),
        "Scrap QTY": parseFloat(item.scrab_qty || 0),
        "Hold Scrap QTY": parseFloat(item.hold_scrap_qty || 0),
      }));

      serialNo++;
      return [...makeItemData, ...buyItemsData, {}];
    });
    exportData.push({
      "Sr. No": "",
      Warehouse: "Total",
      "Item Code": "",
      "Item Desc": "",
      "Stock QTY": totalStockQty,
      "Inward QTY": totalInwardQty,
      "Outward QTY": totalOutwardQty,
      // "Consumable QTY": totalConsumableQty,
      "Shortage QTY": totalShortageQty,
      "Provision QTY": totalProvisionQty,
      "MRB QTY": totalMRBQty,
      "Scrap QTY": totalScrapQty,
      "Hold Scrap QTY": totalHoldScrapQty,
    });
    exportToExcel(exportData, "ViewStockReport.xlsx");
  };

  const totalStockQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.stock_qty) || 0),
      0
    );
  const totalInwardQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.inward_qty) || 0),
      0
    );
  const totalOutwardQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.outward_qty) || 0),
      0
    );

  const totalConsumableQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.consumable_qty) || 0),
      0
    );
  const totalShortageQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.shortage_qty) || 0),
      0
    );
  const totalProvisionQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.provision_qty) || 0),
      0
    );
  const totalMRBQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.mrb_qty) || 0),
      0
    );
  const totalScrapQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.scrab_qty) || 0),
      0
    );
  const totalHoldScrapQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.hold_scrab_qty) || 0),
      0
    );
  return (
    <CustomForm
      title={"View " + headerName}
      loadingData={loadingData}
      id={id}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row>
        <Col md={4}>
          <SelectInput
            label="Warehouse"
            value={warehouseSelect}
            options={warehouseSelectOptions}
            onSelect={(selected) => handleWarehouseSelect(selected)}
            placeholder="Select warehouse"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={(warehouseError && "Please select warehouse.") || ""}
          />
        </Col>
      </Row>

      <Row className="justify-content-center mt-4">
        <Col
          style={{
            marginBottom: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h6
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                backgroundColor: "#f8f9fa",
                padding: "10px 20px",
                borderRadius: "8px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "inline-block",
                margin: "0px",
              }}
            >
              Item Details
            </h6>
          </div>

          <div className="d-flex gap-3">
            <div>
              <div className="app-search d-flex d-lg-inline mt-0 w-25">
                <div className="position-relative">
                  <input
                    type="search"
                    className="form-control ps-5"
                    placeholder="Search by item code.."
                    value={searchKeyword}
                    onChange={handleInputChange}
                    style={{
                      width: "13rem",
                      padding: "8px 15px",
                      borderRadius: "8px",
                      borderColor: "#D2D2D2",
                      outline: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "none",
                      marginRight: "0.5rem",
                    }}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </div>
            </div>

            <div>
              <Button
                color="success"
                className="waves-effect waves-light me-1 mb-2"
                style={{ borderRadius: "50%" }}
                onClick={handleExportData}
              >
                <i class="fas fa-download"></i>
              </Button>
            </div>
          </div>
        </Col>
        <div
          className="table mt-2"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            width: "100%",
            scrollBehavior: "smooth",
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Desc</th>
                <th style={{ whiteSpace: "nowrap" }}>Inward QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Outward QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Stock QTY</th>{" "}
                {/* <th style={{ whiteSpace: "nowrap" }}>Consumable QTY</th> */}
                <th style={{ whiteSpace: "nowrap" }}>Shortage QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Provision QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>MRB QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Scrap QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Hold Scrap QTY</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedItems).length > 0 ? (
                Object.values(groupedItems)?.map((group, index) => (
                  <React.Fragment key={group.makeItem.unique_id}>
                    {group?.makeItem.is_make_item == true && (
                      <tr
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f8ff",
                        }}
                      >
                        <td>{serialNumber++}</td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={group?.makeItem?.item_code || "N/A"}
                          >
                            {group?.makeItem?.item_code || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          {" "}
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={group?.makeItem?.make_item_desc || "N/A"}
                          >
                            {group?.makeItem?.make_item_desc || "N/A"}
                          </div>
                        </td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        {/* <td colSpan="5">{"-"}</td> */}
                      </tr>
                    )}

                    {group?.buyItems?.map((row, subIndex) => {
                      if (row?.is_make_item == true) {
                        return (
                          <tr
                            key={row.unique_id}
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <td>{`${serialNumber - 1}.${subIndex + 1}`}</td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                }}
                                title={row?.buy_item_code || "N/A"}
                              >
                                {row?.buy_item_code || "N/A"}
                              </div>
                            </td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                }}
                                title={row?.description || "N/A"}
                              >
                                {row?.description || "N/A"}
                              </div>
                            </td>

                            <td>{formatNumber(row?.inward_qty || 0)}</td>
                            <td>{formatNumber(row?.outward_qty || 0)}</td>
                            <td>{formatNumber(row?.stock_qty || 0)}</td>
                            {/* <td>{formatNumber(row?.consumable_qty || 0)}</td> */}

                            <td>{formatNumber(row?.shortage_qty || 0)}</td>
                            <td>{formatNumber(row?.provision_qty || 0)}</td>
                            <td>{formatNumber(row?.mrb_qty || 0)}</td>
                            <td>{formatNumber(row?.scrab_qty || 0)}</td>
                            <td>{formatNumber(row?.hold_scrab_qty || 0)}</td>
                          </tr>
                        );
                      }
                    })}
                    {group?.buyItems
                      ?.filter((item) => item.is_make_item == false)
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <td>{serialNumber++}</td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.item_code || "N/A"}
                            >
                              {row?.item_code || "N/A"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>

                          <td>{formatNumber(row?.inward_qty || 0)}</td>
                          <td>{formatNumber(row?.outward_qty || 0)}</td>
                          <td>{formatNumber(row?.stock_qty || 0)}</td>

                          {/* <td>{formatNumber(row?.consumable_qty || 0)}</td> */}
                          <td>{formatNumber(row?.shortage_qty || 0)}</td>
                          <td>{formatNumber(row?.provision_qty || 0)}</td>
                          <td>{formatNumber(row?.mrb_qty || 0)}</td>
                          <td>{formatNumber(row?.scrab_qty || 0)}</td>
                          <td>{formatNumber(row?.hold_scrab_qty || 0)}</td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="13" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              )}
              {(totalStockQty >= 1 ||
                totalInwardQty >= 1 ||
                totalOutwardQty >= 1 ||
                totalShortageQty >= 1 ||
                totalMRBQty >= 1 ||
                totalScrapQty >= 1 ||
                totalHoldScrapQty >= 1 ||
                totalProvisionQty >= 1) && (
                <tr
                  style={{
                    borderTop: "2px solid #cccccc",
                    backgroundColor: "#d9d9d9",
                    fontWeight: "bold",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 0,
                  }}
                >
                  <td></td>
                  <td>Total</td>
                  <td colSpan=""></td>

                  <td>{formatNumber(totalInwardQty)}</td>
                  <td>{formatNumber(totalOutwardQty)}</td>
                  <td>{formatNumber(totalStockQty)}</td>
                  {/* <td>{formatNumber(totalConsumableQty)}</td> */}
                  <td>{formatNumber(totalShortageQty)}</td>
                  <td>{formatNumber(totalProvisionQty)}</td>
                  <td>{formatNumber(totalMRBQty)}</td>
                  <td>{formatNumber(totalScrapQty)}</td>
                  <td>{formatNumber(totalHoldScrapQty)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Row>
    </CustomForm>
  );
};

export default ViewStocks;
